import { render, staticRenderFns } from "./DeviceMonitorTasks.vue?vue&type=template&id=324bb85e&scoped=true"
import script from "./DeviceMonitorTasks.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorTasks.vue?vue&type=script&lang=js"
import style0 from "./DeviceMonitorTasks.vue?vue&type=style&index=0&id=324bb85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bb85e",
  null
  
)

export default component.exports